import { mdiAccountMultiple } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { IRatifier } from '@/types/tasksApprovals'

const CoApprovers = ({ ratifiers }: { ratifiers: IRatifier[] }) => {
    const { t } = useTranslation()
    return (
        <Box pt="12px">
            <AccordionRoot multiple px={0}>
                <AccordionItem border="none" px={0} value={t('tasksApprovals.sailPointCertDrawer.body.coApprovers')}>
                    <AccordionItemTrigger _hover={{ backgroundColor: 'none' }} px="24px">
                        <Flex flexDir="row" width="100%" alignItems="center">
                            <Icon path={mdiAccountMultiple} size="23px" color="var(--chakra-colors-gray-500)" />
                            <Box
                                as="span"
                                fontSize="12px"
                                flex="1"
                                textAlign="left"
                                textTransform="uppercase"
                                ml="6px"
                                color="var(--chakra-colors-gray-500)"
                            >
                                {t('tasksApprovals.sailPointCertDrawer.body.coApprovers')}
                            </Box>
                        </Flex>
                    </AccordionItemTrigger>
                    <AccordionItemContent pb={0} px={0}>
                        <Box as="p" py="12px" pr="12px" fontSize="12px" backgroundColor="rgba(84, 79, 64, 0.08)" pl="24px">
                            {ratifiers.map((ratifier, idx) => `${ratifier.ratifier_name}${idx !== ratifiers.length - 1 ? ', ' : ''}`)}
                        </Box>
                    </AccordionItemContent>
                </AccordionItem>
            </AccordionRoot>
        </Box>
    )
}

export default CoApprovers
